"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Badge = require("./Badge.style");

var _excluded = ["label"];

var Badge = function Badge(_ref) {
  var label = _ref.label,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return label !== '' && /*#__PURE__*/_react["default"].createElement(_Badge.StyledBadge, props, /*#__PURE__*/_react["default"].createElement("span", {
    className: "eui-tag-label"
  }, label));
};

Badge.defaultProps = {
  color: 'white',
  bg: 'primary'
};
Badge.propTypes = {
  label: _propTypes["default"].string,
  className: _propTypes["default"].string,
  color: _propTypes["default"].string,
  bg: _propTypes["default"].string
};
var _default = Badge;
exports["default"] = _default;